import hasRole from './hasRole'
import hasPermi from './hasPermi'
import lacksPermi from './lacksPermi'

const install = function (Vue) {
  Vue.directive('hasRole', hasRole)
  Vue.directive('hasPermi', hasPermi)
  Vue.directive('lacksPermi', lacksPermi)
}

if (window.Vue) {
  window['hasRole'] = hasRole
  window['hasPermi'] = hasPermi
  window['lacksPermi'] = lacksPermi
  Vue.use(install); // eslint-disable-line
}

export default install
